export function currentChallengeMonth(now = new Date()) {
  return `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,"0")}`;
}
export function challengeMonth(value, fallback = currentChallengeMonth()) {
  return typeof value === "string" && /^\d{4}-(0[1-9]|1[0-2])$/.test(value) ? value : fallback;
}
export function challengeMonthLabel(month) {
  const [year,number] = month.split("-").map(Number);
  return new Date(year,number-1,1).toLocaleDateString("en-GB",{month:"long"});
}
export function filmLinkUrl(value) {
  const text = String(value || "").trim();
  if (!text || /\s/.test(text)) return "";
  try {
    const url = new URL(/^[a-z][a-z0-9+.-]*:/i.test(text) ? text : `https://${text}`);
    if (!["http:","https:"].includes(url.protocol) || url.username || url.password) return "";
    const host = url.hostname.toLowerCase();
    const hosts = ["drive.google.com","vimeo.com","youtube.com","youtu.be","dropbox.com"];
    if (!hosts.some(item => host === item || host.endsWith("." + item))) return "";
    return url.href;
  } catch { return ""; }
}
export function challengeClosed(challenge, now = Date.now()) {
  const deadline = typeof challenge?.deadline === "number" ? challenge.deadline : Date.parse(challenge?.deadline);
  return challenge?.status === "closed" || (Number.isFinite(deadline) && deadline > 0 && deadline <= now);
}
export function challengeDate(value, long = false) {
  if (value === null || value === undefined || value === "") return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "—" : date.toLocaleDateString("en-GB",{day:"numeric",month:long?"long":"short"});
}
export function challengePrize(prize) {
  if (prize?.value === undefined || prize?.value === null || prize.value === "") return "—";
  return prize.type === "zylen" ? `${prize.value} Zylen` : `R${prize.value}`;
}
export function challengeEntry(previous, user, link, title, now = Date.now()) {
  return {
    ...(previous || {}),
    name: user.name || user.displayName || "Entrant",
    driveLink:link,
    userId:user.uid,
    canView:true,
    filmTitle:title.trim() || null,
    createdAt:previous?.createdAt ?? now,
    updatedAt:now,
  };
}

